import { Image } from "antd";
import { UnionIcon } from "config/IconConfig";
import * as S from "./MainSider/styles";

interface SiderLogoProps {
  isSiderCollapsed: boolean;
  toggleSider: () => void;
  setCollapsed: any;
}


export const SiderLogo = ({ setCollapsed }: SiderLogoProps) => {
  return (
    <S.SiderLogoDiv>
      <S.SiderLogoLink
        onClick={() => {
          setCollapsed(true);
        }}
      >
        <Image src={UnionIcon} alt="Pegasus" preview={false} />
      </S.SiderLogoLink>
    </S.SiderLogoDiv> 
  );
};
